import { FacebookLogin } from '@capacitor-community/facebook-login';
import { Capacitor } from '@capacitor/core';
import { getEnv } from '@/shared/utils/get-env.ts';

export const FacebookLoginPlugin = {
  async install() {
    try {
      await FacebookLogin.initialize({
        appId: getEnv('VITE_FACEBOOK_PIXEL_APP_ID'),
        autoLogAppEvents: true,
      });

      // Android Manifest already disables this; reinforce from JS so a future
      // SDK/meta-data drift cannot re-enable Advertising ID collection while
      // com.google.android.gms.permission.AD_ID is removed (ANR on cold start).
      if (Capacitor.isNativePlatform()) {
        await FacebookLogin.setAdvertiserIDCollectionEnabled({
          enabled: false,
        });
      }
    } catch (error) {
      console.error('Error initializing Facebook Login:', error);
    }
  },
};
